import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
            剧集推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            剧集推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-2">精选好剧推荐，发现你的下一部心头好</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {cardItems.slice(0, 7).map((item, i) => (
            <article
              key={item.title}
              className={`group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer ${
                i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative w-full ${i === 0 ? 'aspect-[16/9]' : 'aspect-[3/2]'} overflow-hidden`}>
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-semibold text-accent-600">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
                  <i className="ri-calendar-line" />
                  <span>{item.date}</span>
                </div>
                <h3 className={`font-semibold text-foreground-900 leading-snug ${i === 0 ? 'text-lg' : 'text-sm'}`}>
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 mt-2 leading-relaxed line-clamp-2">{item.excerpt}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}